<!-- This exists because text nodes cannot be targeted by css selectors and we want the flexbox layout system to be consistent. -->
<span class="text"><slot>Text</slot></span>
